import React from "react";
import "./tablestyle.scss";

import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridNoRecords
} from "@progress/kendo-react-grid";
import Headline6 from "../../components/headings/Headline6";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

function TimeSheet(Props: any) {

    const checkStatus = (status: string) => {
        switch (status) {
            case '2':
                return {
                    value: 'Pending',
                    class: 'statusMessage Yellow'
                }
            case '3':
                return {
                    value: 'Approved',
                    class: 'statusMessage Green'
                }
            case '4':
                return {
                    value: 'Rejected',
                    class: 'statusMessage Red'
                }
            default:
                return {
                    value: '',
                    class: ''
                }
        }
    }
    
  
    const statusCell = (props: GridCellProps) => {
        return (
            <td>
                <div className={checkStatus(props.dataItem.timesheetStatus).class}>
               {checkStatus(props.dataItem.timesheetStatus).value}
            </div>
            </td>
        )
    }

    const historyCell = (props: GridCellProps) => {
        return (
            <td>
                <Link to={''} onClick={() => Props.showHistory(props.dataItem)}><Icon icon="bx:history"width="25" style={{'color':'rgba(0, 0, 0, 0.6)'}} ></Icon></Link>
            </td>
        )
    }

    const buttonClick = (data: any) => {
        if (data.timesheetStatus === '2') {
            Props.sendReminder(data)
        }
    }


    const editOrRemind = (props: GridCellProps) => {
     
        let activeStatus = props.dataItem.activeStatus
        switch (Props.title) {
            case 'currentTimesheet':
                return (
                    <td>
                        <Link to={'/addTimesheet'} style={{ 'color': '#14A800'}} state={{ state: props.dataItem }}>{activeStatus ? 'Edit' : 'Create New'}</Link>
                    </td>
                )
            case 'timesheetHistory':
                return (
                    <td>
                        <Link style={{ 'color': 'green' }} onClick={() => buttonClick(props.dataItem)} to={props.dataItem.timesheetStatus === '4' ? '/addTimesheet' : ''} state={{ state: props.dataItem }}>{props.dataItem.timesheetStatus === '2' ? 'Send Reminder' : props.dataItem.timesheetStatus=== '4' ? 'Edit': ''}</Link>
                    </td>
                )
            default:
                return (
                    <td>
                        
                    </td>
                )
         }
    }

    const durtionCell = (props: GridCellProps) => {
        return (
            <td>
                {(new Date(parseInt(props.dataItem.startDate))).toDateString().slice(3) + ' - ' + (new Date(parseInt(props.dataItem.endDate))).toDateString().slice(3)}
            </td>
        )
    }

    const submittedonCell = (props: GridCellProps) => {
        return (
            <td>
                {props.dataItem.submittedOn && new Date(parseInt(props.dataItem.submittedOn)).toDateString().slice(3)}
        </td>
    )
    }
    
    const ViewButton = (props: GridCellProps) => {
        return (
            <td>
        <Link to={'/addTimesheet'} style={{ 'color': '#14A800'}} state={{ state: props.dataItem }}>View</Link>
          </td>
      )
    }

  return (
      <>
          {Props.title === 'currentTimesheet' ?
              <div>
                  <Headline6>Draft</Headline6>
                  <Grid
                  data={Props.data}
              >
                <GridNoRecords>
                    <div className="noData">
                    <Icon icon="mdi:smiley-neutral-outline" />
                    No data to display
                    </div>
                </GridNoRecords>
                  <Column cell={durtionCell} title="Duration" className="noWordWrap" />
                  <Column field="projectName" title="Project Name" />
                  <Column cell={editOrRemind} width="120"/>

              </Grid>
              </div> : 
              <div>
                        <Grid
                  data={Props.data}
              >
                 <GridNoRecords>
                    <div className="noData">
                    <Icon icon="mdi:smiley-neutral-outline" />
                    No data to display
                    </div>
                </GridNoRecords>
                  <Column cell={durtionCell} title="Duration" width="200" className="noWordWrap" />
                  <Column field="projectName" title="Project" width="100" className="wordBreak" /> 
                  <Column field="submittedOn" title="Submitted On" width="100" cell={submittedonCell} />
                  <Column field="submittedTo" title="Submitted To" className="wordBreak" />
                  <Column field="verifiedBy" title="Verified By"  className="wordBreak" />
                  <Column field="status" title="Status"  width="80" cell={statusCell} />
                  <Column cell={historyCell} width="40"/>
                  <Column cell={editOrRemind} width="120" />
                  {Props.title === 'timesheetHistory' &&<Column cell={ViewButton} width="120" />}            
              </Grid>
              </div>
          }
          
          
    </>
  );
}

export default TimeSheet;
